export default "__VITE_ASSET__eoQUPWpi__"